import axios from 'axios'

export type Interest = {
  id: string
  name: string
  image: string | null
  createdAt: string
  updatedAt: string | null
}

export const getInterestsService = async (): Promise<Interest[]> => {
  const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/interests`)
  console.log('interests: ', data)
  return data
}
